import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VueApexCharts from 'vue-apexcharts';

//Importing the class icons font
import "./assets/css/fontello.css"

Vue.config.productionTip = false;
Vue.component("apexchart", VueApexCharts)

//Defines a global object that holds classImages, accessible under $classImages. Needs to be replaced with cdn/api images in component level once ready
const classImages = {
  cardImages: {
    archer:
      "https://images.mein-mmo.de/medien/2018/12/Black-Desert-Archer-Titel.jpg",
    shai:
      "https://akamai-webcdn.blackdesertonline.com/bdo/resources/news/93d764478db38b54c113ccb1423b0c07.jpg",
    hashashin:
      "https://cdn.mmos.com/wp-content/uploads/2020/07/black-desert-online-hashashin-banner.jpg",
    lahn: "https://images.mein-mmo.de/medien/2020/02/Lahn-BDO-Header.jpg",
    musa: "https://steparu.com/images/0515/bdo-musa-awakening.jpg",
    guardian:
      "https://www.freemmostation.com/wp-content/uploads/2020/01/Black-Desert-Online-Guardian-awakening-600x150.jpg"
  },
  bannerImages: {
    hashashin: "https://akamai-webcdn.blackdesertonline.com/bdo/resources/news/include/8fcf6ebf47a7264ffa0fec92635bb516.jpg",
    maewha: "https://cdn.discordapp.com/attachments/504731551741771779/736851396778917888/2020-07-25_873211953.JPG",
    musa: "https://cdn.discordapp.com/attachments/666228815785230359/753222242258780240/class20_awaken_img_1-817x320.png",
    sorceress: "https://s1.playblackdesert.com/web/Static/contents/img/portal/gameinfo/awakening_character_28_char.jpg"
  }
}
Vue.prototype.$classImages = classImages

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
